import type { FooterColumn } from "@/hooks/useFooterConfig";

export const DEFAULT_FOOTER_COLUMNS: FooterColumn[] = [
  { title: "COMPANY", links: [{ label: "About Us", href: "/about" }, { label: "Contact Us", href: "/contact" }] },
  { title: "FOR PROVIDERS", links: [{ label: "Become Pro", href: "/vendor-register" }] },
  { title: "LEGAL", links: [{ label: "Privacy Policy", href: "/privacy" }, { label: "Terms of Service", href: "/terms" }] },
];

export const DEFAULT_FOOTER_COPYRIGHT = "© 2026 VendorCall. All rights reserved.";
export const DEFAULT_FOOTER_BRAND = "VendorCall";
